<template>
  <ul class="mission-honeycomb" :class="{ 'is-completed': mission.hasCompleted }">
    <li
      v-for="(condition, index) in mission.achievementCondition"
      :key="index"
      class="mission-honeycomb__item"
    >
      <mission-hexagon-parts
        :condition="condition"
        :prevCondition="getPrevCondition(index)"
        :mission="mission"
        :checkInMissionsBeingHeld="checkInMissionsBeingHeld"
      />
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import MissionHexagonParts from '@/components/MissionPage/MissionListPane/parts/MissionHexagonParts.vue'
import { MissionProgressCardType } from '@/components/MissionPage/hook/useMissionProgressData'
import MissionProgressDocument from '@/store/stores/collectionModule/documents/mission/MissionProgressDocument'

/**
 * ミッション画面 ミッション達成状況 ハニカム8個パーツ
 */
export default defineComponent({
  name: 'MissionHoneycombEightParts',
  components: {
    MissionHexagonParts,
  },
  props: {
    mission: {
      type: Object as PropType<MissionProgressCardType>,
      required: true,
    },
    /**
     * 開催中のラウンドチェックインまたはイベントチェックインミッション一覧
     */
    checkInMissionsBeingHeld: {
      type: Array as PropType<MissionProgressDocument[]>,
      required: true,
    },
  },
  setup(props) {
    /**
     * 一つ前の達成条件を取得する
     */
    const getPrevCondition = (index: number) =>
      index > 0 ? props.mission.achievementCondition?.[index - 1] : 'noPreviousCondition'

    return {
      getPrevCondition,
    }
  },
})
</script>

<style scoped lang="scss">
.mission-honeycomb {
  display: flex;
  gap: min(#{convertPXtoVW(6)}, 6px);
  flex-wrap: wrap;
  width: min(#{convertPXtoVW(309)}, 309px);

  &__item {
    flex-shrink: 0;

    &:nth-child(5) {
      margin-left: min(#{convertPXtoVW(35)}, 35px);
    }

    &:nth-child(n + 5) {
      margin-top: max(-#{convertPXtoVW(19)}, -19px);
    }

    ::v-deep {
      .mission-card-hexagon {
        width: min(#{convertPXtoVW(64)}, 64px);
        height: min(#{convertPXtoVW(73)}, 73px);
      }

      .mission-card-hexagon__outer {
        width: min(#{convertPXtoVW(64)}, 64px);
        height: min(#{convertPXtoVW(73)}, 73px);
      }

      .mission-card-hexagon__inner {
        width: min(#{convertPXtoVW(56)}, 56px);
        height: min(#{convertPXtoVW(63)}, 63px);
      }
    }
  }

  &.is-completed {
    width: min(#{convertPXtoVW(242)}, 242px);

    .mission-honeycomb__item {
      &:nth-child(5) {
        margin-left: min(#{convertPXtoVW(27)}, 27px);
      }

      &:nth-child(n + 5) {
        margin-top: max(-#{convertPXtoVW(15)}, -15px);
      }

      ::v-deep {
        .mission-card-hexagon {
          width: min(#{convertPXtoVW(49)}, 49px);
          height: min(#{convertPXtoVW(57)}, 57px);
        }

        .mission-card-hexagon__outer {
          width: min(#{convertPXtoVW(49)}, 49px);
          height: min(#{convertPXtoVW(57)}, 57px);
        }

        .mission-card-hexagon__inner {
          width: min(#{convertPXtoVW(43)}, 43px);
          height: min(#{convertPXtoVW(49)}, 49px);
        }
      }
    }
  }

  @media screen and (min-width: $responsiveTabletWidth) {
    width: min(#{convertPXtoVW(418)}, 418px);

    &__item {
      &:nth-child(5) {
        margin-left: min(#{convertPXtoVW(47)}, 47px);
      }

      &:nth-child(n + 5) {
        margin-top: max(-#{convertPXtoVW(26)}, -26px);
      }

      ::v-deep {
        .mission-card-hexagon {
          width: min(#{convertPXtoVW(88)}, 88px);
          height: min(#{convertPXtoVW(100)}, 100px);
        }

        .mission-card-hexagon__outer {
          width: min(#{convertPXtoVW(88)}, 88px);
          height: min(#{convertPXtoVW(100)}, 100px);
        }

        .mission-card-hexagon__inner {
          width: min(#{convertPXtoVW(77)}, 77px);
          height: min(#{convertPXtoVW(86)}, 86px);
        }
      }
    }

    &.is-completed {
      width: min(#{convertPXtoVW(418)}, 418px);

      .mission-honeycomb__item {
        &:nth-child(5) {
          margin-left: min(#{convertPXtoVW(47)}, 47px);
        }

        &:nth-child(n + 5) {
          margin-top: max(-#{convertPXtoVW(26)}, -26px);
        }

        ::v-deep {
          .mission-card-hexagon {
            width: min(#{convertPXtoVW(88)}, 88px);
            height: min(#{convertPXtoVW(100)}, 100px);
          }

          .mission-card-hexagon__outer {
            width: min(#{convertPXtoVW(88)}, 88px);
            height: min(#{convertPXtoVW(100)}, 100px);
          }

          .mission-card-hexagon__inner {
            width: min(#{convertPXtoVW(77)}, 77px);
            height: min(#{convertPXtoVW(86)}, 86px);
          }
        }
      }
    }
  }
}
</style>
